import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createAdminValidationSchema = Yup.object().shape({
  fullName: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  username: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  password: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  email: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
